import React from 'react'
import { Row, Col } from 'react-bootstrap'

import { DocSidebar } from './doc-sidebar'
import { DocContainerNoMenu } from './doc-container-no-menu'
export const DocContainer = ({ children, blogTitle = '' }) => (
  <DocContainerNoMenu blogTitle={blogTitle}>
    <Row>
      <Col lg={8} className="entries">
        {children}
      </Col>
      <Col lg={4}>
        <DocSidebar />
      </Col>
    </Row>
  </DocContainerNoMenu>
)
